import { Component } from '@angular/core';
import {LoanApplicationService} from '../../loan-application.service';
import {LoanApplication} from '../../../../@models/loan-application.model';

@Component({
  selector: 'bb-seaman',
  templateUrl: './seaman.component.html',
  styleUrls: ['./seaman.component.scss']
})
export class SeamanComponent {
  employment_channel = LoanApplication.EmploymentChannel;
  employment_info = this.loan.form.get('employment_info');
  constructor(public loan: LoanApplicationService) { }
}
